export class ApiError extends Error {
  status: number;
  campos?: Record<string, string>;
  recuperacao?: string;
  duplicidades?: unknown[];
  mfaNecessario?: boolean;

  constructor(
    status: number,
    payload: {
      erro?: string;
      campos?: Record<string, string>;
      recuperacao?: string;
      duplicidades?: unknown[];
      mfa_necessario?: boolean;
    },
  ) {
    super(payload.erro || "Não foi possível concluir a solicitação.");
    this.status = status;
    this.campos = payload.campos;
    this.recuperacao = payload.recuperacao;
    this.duplicidades = payload.duplicidades;
    this.mfaNecessario = payload.mfa_necessario;
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const method = String(init?.method || "GET").toUpperCase();
  if (method !== "GET" && !navigator.onLine) {
    throw new ApiError(0, {
      erro: "Sem conexão com a central operacional.",
      recuperacao:
        "Reconecte-se antes de registrar ou alterar dados. Nenhuma ação foi enfileirada.",
    });
  }
  const response = await fetch(`/api${path}`, {
    credentials: "include",
    ...init,
    headers: {
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(response.status, payload);
  return payload as T;
}

export function jsonBody(
  value: unknown,
): Pick<RequestInit, "body" | "headers"> {
  return {
    body: JSON.stringify(value),
    headers: { "Content-Type": "application/json" },
  };
}
